import React from 'react';
import { Col, FormGroup, Row } from 'react-bootstrap';
import { TextBox } from 'fw/forms';
import { ActionButton, Label } from 'fw/components';
import { SetupTab } from 'areas/shared/pages/setup';
import * as Modals from 'fw/globals/Modals'
import * as App from 'modules/app/App'
import * as API from 'modules/app/API'

class DenialCodeInfoTab extends SetupTab {
    initialForm() {
        return {
            denialCodeId: 0,
            code: "",
            description: ""
        }
    }

    privileges() {
        return {
            add: App.hasPrivilege("AdminDenialCodeSetupAdd"),
            edit: App.hasPrivilege("AdminDenialCodeSetupEdit")
        }
    }

    urls() {
        return {
            get: API.App.url('/DenialCodeSetup/getDenialCodeInfo'),
            save: API.App.url('/DenialCodeSetup/saveDenialCodeInfo'),
            create: API.App.url('/DenialCodeSetup/createDenialCodeInfo')
        }
    }

    getRequest(selectedId) {
        return {
            denialCodeId: selectedId
        }
    }

    saveRequest() {
        return {
            denialCodeId: this.state.form.denialCodeId,
            code: this.state.form.code,
            description: this.state.form.description
        }
    }

    ready = () => {
        this.focusControl && this.focusControl.focus();
    }

    handleDelete = () => {
        const me = this;
        Modals.remove({
            title: "Deleting Denial Code",
            elementType: "Denial Code",
            name: this.state.form.code,
            onYes: () => {
                API.App.post('/DenialCodeSetup/deleteDenialCode', { denialCodeId: me.props.selectedId },
                {
                    success: (r) => {
                        me.props.onSuccess(r.message);
                        me.props.onDelete();
                    },
                    error: (r) => {
                        me.props.onError(r.error);
                    }
                });
            }
        });
    }

    renderActions() {
        if (this.state.adding)
            return null;

        return (
            <div className="pull-right">
                <ActionButton id="btnDeleteDenialCode" onClick={this.handleDelete} icon="trash">Delete Denial Code</ActionButton>
            </div>
        )
    }

    renderForm() {
        return (
            <React.Fragment>
                <Row>
                    <Col md={3}>
                        <FormGroup>
                            <Label required>Code</Label>
                            <TextBox
                                name="code"
                                placeholder="Code"
                                maxLength={10}
                                required
                                ref={(c) => { this.focusControl = c; }} />
                        </FormGroup>
                    </Col>
                    <Col md={8}>
                        <FormGroup>
                            <Label>Description</Label>
                            <TextBox
                                name="description"
                                placeholder="Description"
                                maxLength={255} />
                        </FormGroup>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }
}

export default DenialCodeInfoTab;



// WEBPACK FOOTER //
// ./src/areas/admin/denialCodeSetup/denialCodeInfo/DenialCodeInfoTab.js